import React, { useRef, useEffect, useCallback } from 'react';

import { Text, ModalBase } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';
import { useTranslate } from 'soluble-gatsby-source';


export default function ModalCommunicationsPreventExit({
    onExit
}) {
    const translate = useTranslate();

    const modalRef = useRef();
    
    useEffect(() => {
        modalRef.current.toggle();
    }, []);

    const onClickBack = useCallback(
        () => {
            modalRef.current.toggle();
        },
        [ modalRef ]
    );

    const onClickExit = useCallback(
        () => {
            if (onExit) {
                onExit();
            }
            
            modalRef.current.toggle();
        },
        [ modalRef ]
    );
    
    return (
        <ModalBase
            parentRef={modalRef}
            title={translate['communications-page.pending-modal.title'].text}
            size="md"
            warning={true}
            disableBackgroundClose={true}
            hideClose={true}
            footer={(
                <ButtonComponent
                    buttons={[
                        {
                            detached: true,
                            Tag: 'button',
                            onClick: onClickBack,
                            label: translate['communications-page.pending-modal.cta.back'].text,
                            block: true
                        },
                        {
                            detached: false,
                            Tag: 'button',
                            onClick: onClickExit,
                            label: translate['communications-page.pending-modal.cta.exit'].text,
                            block: true
                        }
                    ]}
                />
            )}
        >
            <Text tag="div" className="body text-center pb-5 pb-lg-11">
                {translate['communications-page.pending-modal.text'].md}
            </Text>
        </ModalBase>
    );
}